module.exports = __webpack_public_path__ + "img/mooctest.6207a74d.png";